import styled from "styled-components";
import { ButtonBase } from "@mui/material";

export const LoginButton = styled(ButtonBase)`
  && {
    width: 205px;
    height: 47px;
    background: #f2753b;
    box-shadow: -2px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;

    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

export const NavItem = styled(ButtonBase)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

export const ProfileItem = styled(ButtonBase)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    justify-content: start;
    letter-spacing: 0.05em;
    color: ${(props) => props.logoutColor || "#ffffff"};
    padding-left: 20px;
    width: 100%;
  }
`;
